import * as types from "./TenantHierarchyConfigurationActionType";

export const getMasterHierarchyRequest = () => ({
  type: types.GET_MASTER_HIERARCHY_REQUEST,
});

export const getMasterHierarchySuccess = (data) => ({
  type: types.GET_MASTER_HIERARCHY_SUCCESS,
  payload: data,
});

export const getMasterHierarchyFailure = (error) => ({
  type: types.GET_MASTER_HIERARCHY_FAILURE,
  payload: error,
});

export const getTenantHierarchyConfigurationRequest = (tenantId) => ({
  type: types.GET_TENANT_HIERARCHY_CONFIGURATION_REQUEST,
  payload: tenantId,
});

export const getTenantHierarchyConfigurationSuccess = (data) => ({
  type: types.GET_TENANT_HIERARCHY_CONFIGURATION_SUCCESS,
  payload: data,
});

export const getTenantHierarchyConfigurationFailure = (error) => ({
  type: types.GET_TENANT_HIERARCHY_CONFIGURATION_FAILURE,
  payload: error,
});

export const saveTenantHierarchyConfigurationRequest = (data) => ({
  type: types.SAVE_TENANT_HIERARCHY_CONFIGURATION_REQUEST,
  payload: data,
});

export const saveTenantHierarchyConfigurationSuccess = (data) => ({
  type: types.SAVE_TENANT_HIERARCHY_CONFIGURATION_SUCCESS,
  payload: data,
});

export const saveTenantHierarchyConfigurationFailure = (error) => ({
  type: types.SAVE_TENANT_HIERARCHY_CONFIGURATION_FAILURE,
  payload: error,
});

export const bulkUpdateTenantHierarchyAliasRequest = (data) => ({
  type: types.BULK_UPDATE_TENANT_HIERARCHY_ALIAS_REQUEST,
  payload: data,
});

export const bulkUpdateTenantHierarchyAliasSuccess = (data) => ({
  type: types.BULK_UPDATE_TENANT_HIERARCHY_ALIAS_SUCCESS,
  payload: data,
});

export const bulkUpdateTenantHierarchyAliasFailure = (error) => ({
  type: types.BULK_UPDATE_TENANT_HIERARCHY_ALIAS_FAILURE,
  payload: error,
});

export const resetTenantHierarchyConfigurationFlags = () => ({
  type: types.RESET_TENANT_HIERARCHY_CONFIGURATION_FLAGS,
});
